<!--
 - Author : wanghongling.
 - Date   : 2021/2/3.
 - File   : sensor.传感器弹窗
 -->

<template>
  <datePopover :title="currentPos.name"
      width="500px"
      v-show="showTag"
      :aqiMsg="currentPos"
      class="wave-bar"
      :style="{position:'absolute', left: boxPositionStyle.left+'px', top: boxPositionStyle.top, bottom:
               boxPositionStyle.bottom}"
      @selectTimeFn="changeTime"
      @closeEvent="closeEvent">
    <div class="sensor" v-show="HisOrExceptionList && HisOrExceptionList.length>0">
      <div class="sensor-item" v-for="(item, index) in HisOrExceptionList" :key="index">
        <el-tooltip class="item" effect="light"
            :content="`${item.content}`"
            placement="top">
          <p class="sensor-item-title">{{item.content}}</p>
        </el-tooltip>
        <p class="sensor-item-time">{{item.occurrenceTime}}</p>
      </div>
    </div>
    <div class="no-the-data" style="height: 260px" v-show="(HisOrExceptionList && HisOrExceptionList.length===0) && totalCount===0">
      <div>
        <i class="iconfont icon-content-likes dzi"></i>
        <p>暂无异常数据</p>
      </div>
    </div>
    <div class="tem-page">
      <el-pagination
          background
          :page-size="parseInt(pageSize)"
          :current-page.sync="nowPage"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="totalCount">
      </el-pagination>
    </div>
  </datePopover>
</template>

<script>
  import dayjs from 'dayjs'
  export default {
    name: 'sensor',
    data () {
      return {
        nowPage: 1
      }
    },
    props: {
      showTag: {
        default: true
      },
      currentPos: {
        date: dayjs().format('YYYY-MM-DD')
      },
      totalCount: {},
      pageSize: {
        default: 8
      },
      boxPositionStyle: {
        default: () => {
          return {
            left: 100,
            top: 100,
            bottom: 100
          }
        }
      },
      HisOrExceptionList: {}
    },
    methods: {
      /**
       * @Description:切换时间
       * @author wanghongling
       * @createDate 2021/2/3
      */
      changeTime(val) {
        console.log('传感器切换时间val', val)
        this.$emit('changeTime', val)
      },
      /**
       * @Description:关闭事件
       * @author wanghongling
       * @createDate 2021/2/3
      */
      closeEvent() {
        this.$emit('closeEvent', '01')
      },
      /**
       * @Description:分页切换
       * @author wanghongling
       * @createDate 2021/2/3
      */
      handleCurrentChange(e) {
        this.nowPage = e
        this.$emit('handleCurrentChange', e)
      }
    }
  }
</script>

<style lang="less" scoped>
  .sensor {
    padding: 0 0 10px;
    min-height: 90px;
    &-item{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-title{
        font-size: 14px;
        color: #00fffc;
        max-width: 310px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-time{
        font-size: 13px;
        color: #83adbb;
      }
    }
  }

  /*分页样式*/

  /deep/.el-pagination {
    margin-bottom: 6px;
    text-align: center;
  }

  /deep/.el-pagination.is-background /deep/.el-pager li {
    background-color: inherit;
    color: #0aaade;
    font-size: 14px;
    font-weight: normal;
  }

  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev {
    background: inherit;
    color: #0aaade;
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #004270 !important;
    color: #00ffff;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    color: rgba(255, 255, 255, 1);
    background: #216784;
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/sensorBox/sensor.vue